import React, { useMemo } from "react";
import CustomDataTable from "components/customs/table";
import styled from "styled-components";
import committeeTabColumns from "./committeeTabColumns";

const Container = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const CommitteeTab = ({ committeeDetails }) => {
  const columns = useMemo(() => committeeTabColumns(), []);

  const data = useMemo(() => {
    if (
      !Array.isArray(committeeDetails?.memberships?.rows) ||
      committeeDetails?.memberships?.rows?.length === 0
    ) {
      return [];
    }

    return committeeDetails.memberships.rows;
  }, [committeeDetails?.memberships?.rows]);

  // Set max height when data exceeds 10 rows or reaches certain height
  const maxRowsBeforeScroll = 10;
  const rowHeight = 50; // Approximate height per row in pixels
  const headerHeight = 60; // Approximate header height
  const maxHeight = 600; // Maximum height in pixels

  // Calculate height: if data exceeds threshold, limit to maxRowsBeforeScroll,
  // otherwise use actual row count, capped at maxHeight
  const rowCount =
    data.length > maxRowsBeforeScroll ? maxRowsBeforeScroll : data.length;

  const calculatedHeight =
    data.length > 0
      ? `${Math.min(rowCount * rowHeight + headerHeight, maxHeight)}px`
      : "auto";

  return (
    <Container>
      <CustomDataTable
        columns={columns}
        data={data}
        pagination={false}
        noHeader={false}
        height={calculatedHeight}
      />
    </Container>
  );
};

export default CommitteeTab;
